import { render, staticRenderFns } from "./CasoAvaliacao.vue?vue&type=template&id=991f62ac"
import script from "./CasoAvaliacao.vue?vue&type=script&lang=js"
export * from "./CasoAvaliacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports